/**
 * T82Element — Base class for all Terminal 82 Lit components.
 *
 * Key decisions:
 * - Light DOM (no Shadow DOM) so global CSS from studio.css applies
 * - Existing event delegation on #app sees component internals
 * - emit() helper for bubbling custom events
 */

import { LitElement } from 'lit';

export class T82Element extends LitElement {
  /** Reactive collapsed state — triggers re-render via requestUpdate. */
  private _collapsed = false;
  get collapsed(): boolean { return this._collapsed; }
  set collapsed(v: boolean) {
    const old = this._collapsed;
    this._collapsed = v;
    this.requestUpdate('collapsed', old);
  }

  /** Render into light DOM so global CSS applies. */
  override createRenderRoot() {
    return this;
  }

  /** Fire a bubbling custom event. */
  protected emit(name: string, detail?: unknown) {
    this.dispatchEvent(
      new CustomEvent(name, { detail, bubbles: true, composed: true }),
    );
  }

  /** Toggle section collapse — skips clicks on inputs/selects inside header. */
  protected _toggleCollapse(e: Event) {
    const target = e.target as HTMLElement;
    if (target.closest('select') || target.closest('input')) return;
    e.stopPropagation();
    this.collapsed = !this.collapsed;
  }
}
